import React from "react"

interface Props {
  isEng: boolean;
}


export class RuntimeFooterComponent extends React.Component<Props> {

  constructor(props: Props) {
    super(props);

  }

  generateFooterString=()=>{
    return (
    <footer className='ontario-footer ontario-footer--default'>
      <div className='ontario-row'>
         <nav className='ontario-columns ontario-small-12' aria-label="footer">
          <ul className='ontario-footer__links-container ontario-footer__links-container--inline'>
            <li><a className='ontario-footer__link' href={this.props.isEng? 'https://www.ontario.ca/page/accessibility':'https://www.ontario.ca/fr/page/accessibilite'}>{this.props.isEng? 'Accessibility' : 'Accessibilité'}</a></li>
            <li><a className='ontario-footer__link' href={this.props.isEng ?'https://www.ontario.ca/page/privacy-statement':'https://www.ontario.ca/fr/page/declaration-concernant-la-protection-de-la-vie-privee'}>{this.props.isEng ? 'Privacy' : 'Confidentialité'}</a></li>
            <li><a className='ontario-footer__link' href={this.props.isEng ? 'https://www.ontario.ca/feedback/contact-us':'https://www.ontario.ca/feedback/contact-us'}>{this.props.isEng ? 'Contact us' : 'Communiquez avec nous'}</a></li>
            <li><a className='ontario-footer__link' href={this.props.isEng ?'https://www.ontario.ca/page/terms-use':'https://www.ontario.ca/fr/page/conditions-dutilisation'}>{this.props.isEng ? 'Terms of Use' : "Condition d’utilisation"}</a></li>
          </ul>
          <div className='ontario-footer__copyright'>
            <a className='ontario-footer__link' href='https://www.ontario.ca/page/copyright-information'>{this.props.isEng ? "© King's Printer for Ontario," : "© Imprimeur du Roi pour l’Ontario,"}
              <span className='ontario-nbsp'>2012&ndash;25</span></a>
          </div>
        </nav>
      </div>
    </footer>
  )
}

render() {  
  return (
    <>
      {this.generateFooterString()}
    </>
  )
}
}
